import { useEffect } from 'react';
import { useTheme } from 'styled-components';

import { Router } from '@/app/providers/router';
import * as Styled from '@/app/styles/app-layouts';
import { useUserInitQuery } from '@/entities/user/api/user.api';
import { showZendeskWidget, updateZendeskWidgetSettings } from '@/shared/lib/helpers/zendesk-widget.helper';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';
import { Header } from '@/widgets/header';
import { Sidebar } from '@/widgets/sidebar';

export const NOT_ACTIVE = 'Not Active';

const HtmlContentComponent = () => {
	const isMobile = useMatchMedia('mobile');
	const { refetch } = useUserInitQuery(null);
	const { button } = useTheme();

	useEffect(() => {
		showZendeskWidget();
	}, []);

	useEffect(() => {
		const updateIframeSize = () => {
			const zendeskIframe = document.querySelector("iframe[id*='launcher']") as HTMLIFrameElement;

			if (!zendeskIframe) return;

			const iframeDocument = zendeskIframe.contentDocument || zendeskIframe.contentWindow?.document;

			if (iframeDocument) {
				const launcherElement = iframeDocument.querySelector('[data-testid="launcher"]') as HTMLElement;

				if (launcherElement) {
					zendeskIframe.style.width = `${launcherElement.offsetWidth}px`;
				}
			}
		};

		updateIframeSize();

		window.addEventListener('resize', updateIframeSize);

		return () => window.removeEventListener('resize', updateIframeSize);
	}, []);

	useEffect(() => {
		updateZendeskWidgetSettings({
			color: {
				theme: button.contained.background,
				launcher: button.contained.background,
				button: button.contained.background,
			},
		});
	}, [button.contained.background]);

	useEffect(() => {
		const intervalId = setInterval(() => {
			refetch();
		}, 3 * 60 * 60 * 1000);

		return () => clearInterval(intervalId);
	}, [refetch]);

	return (
		<>
			{!isMobile && <Sidebar />}
			<Styled.ContentWrapper>
				{isMobile && <Header />}
				<Router />
			</Styled.ContentWrapper>
		</>
	);
};

export default HtmlContentComponent;
